import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import Contact from '../components/Contact';
import SEO from '../components/SEO';

const ContactPage = () => {
  return (
    <>
      <SEO 
        title="Contact CodeRidge | Free Infrastructure Audit & Enterprise IT"
        description="Request a free infrastructure audit or speak with CodeRidge about automation, cybersecurity, Cloud 3.0, and managed IT. Hyderabad, India."
        keywords="contact CodeRidge, infrastructure audit, managed IT contact, enterprise security consulting, Hyderabad"
        url="https://coderidge.in/contact"
      />
      <Navbar />
      <div style={{ paddingTop: '80px' }}>
        <Contact />
      </div>
      <Footer />
    </>
  );
};

export default ContactPage;










